// expects rform state
// return obj with thruthy values keys only

export default function getEditedKeysOnly(state) {
  return Object.keys(state).reduce((obj, key) => {
    if (state[key]) {
      obj[key] = state[key];
    }
    return obj;
  },{});
}
